import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  globalBookingsSearchBox: {
    [theme.breakpoints.down('md')]: {
      margin: '0.5rem 0 0 0',
    },
  }
}));
